import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ProvidersIntl"] */ "/app/app/providers-intl.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConditionalLayout"] */ "/app/components/layout/conditional-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PerformanceMonitor"] */ "/app/components/performance-monitor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TimerProtection"] */ "/app/components/time/timer-protection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VersionChecker"] */ "/app/components/version-checker.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
